import { lazy } from "react";

export const Home = lazy(() => import("@/Pages/Home"));
export const Credentials = lazy(() => import("@/Pages/Credentials"));
export const BusinessTypes = lazy(() => import("@/Pages/BusinessTypes"));
export const CommodityType = lazy(() => import("@/Pages/CommodityTypes"));
export const Specialization = lazy(() => import("@/Pages/Specialization"));
export const CommissionSetting = lazy(
  () => import("@/Pages/CommissionSetting")
);
export const CattleTypes = lazy(() => import("@/Pages/CattleTypes"));
export const CurrencyType = lazy(() => import("@/Pages/CurrencyType"));
export const CattleBreeds = lazy(() => import("@/Pages/CattleBreeds"));
export const WorkerType = lazy(() => import("@/Pages/WorkerType"));
export const CardType = lazy(() => import("@/Pages/CardType"));
export const Cards = lazy(() => import("@/Pages/Cards"));
export const Profile = lazy(() => import("@/Pages/Profile"));
export const Loading = lazy(() => import("@/Pages/Loading"));
export const Segments = lazy(() => import("@/Pages/Segments"));
export const Roles = lazy(() => import("@/Pages/Roles"));
export const Users = lazy(() => import("@/Pages/Users"));
export const PartnerRoles = lazy(() => import("@/PartnerPages/Roles"));
export const Insurers = lazy(() => import("@/Pages/Insurers"));
export const Products = lazy(() => import("@/Pages/Products"));
export const ProductFeatures = lazy(() => import("@/Pages/ProductFeatures"));
export const Cities = lazy(() => import("@/Pages/City"));
export const FeatureMaster = lazy(() => import("@/Pages/FeatureMaster"));
export const States = lazy(() => import("@/Pages/State"));
export const Countries = lazy(() => import("@/Pages/Countries"));
export const Alerts = lazy(() => import("@/Pages/Alert"));
export const Pincodes = lazy(() => import("@/Pages/Pincodes"));
export const Relations = lazy(() => import("@/Pages/Relations"));
export const Partners = lazy(() => import("@/Pages/Partners"));
export const PaymentMode = lazy(() => import("@/Pages/PaymentMode"));
export const BankBranches = lazy(() => import("@/Pages/BankBranches"));
export const Plans = lazy(() => import("@/Pages/Plans"));
export const CertificateTemplates = lazy(
  () => import("@/Pages/CertificateTemplates")
);
export const PropertyCoverages = lazy(
  () => import("@/Pages/PropertyCoverages")
);
export const CancellationReasons = lazy(() => import("@/Pages/CancelReasons"));
export const Theme = lazy(() => import("@/Pages/Theme"));
export const GeneralSettings = lazy(() => import("@/Pages/GeneralSettings"));
export const AlertTemplate = lazy(() => import("@/Pages/Alert Templates"));
export const Policies = lazy(() => import("@/Pages/Policies"));
export const PolicyFeatures = lazy(() => import("@/Pages/PolicyFeatures"));
export const Leads = lazy(() => import("@/Pages/Leads"));
export const Accounts = lazy(() => import("@/Pages/Accounts"));
export const DefaultAlertTemplate = lazy(
  () => import("@/Pages/DefaultAlertTemplate")
);
export const ApiToken = lazy(() => import("@/PartnerPages/ApiToken"));
export const CashDeposit = lazy(() => import("@/Pages/CashDeposite"));
export const JourneyLinksPage = lazy(
  () => import("@/Pages/CustomerJourneyLink")
);
export const PartnerPermissions = lazy(
  () => import("@/Pages/PartnerPermissions")
);
export const PermissionsPage = lazy(() => import("@/Pages/Permissions"));
export const Combos = lazy(() => import("@/Pages/Combos"));
export const Transactions = lazy(() => import("@/Pages/Transactions"));
export const Species = lazy(() => import("@/Pages/Species"));
export const Entity = lazy(() => import("@/Pages/Entity"));
export const Breeds = lazy(() => import("@/Pages/Breeds"));
export const Coupons = lazy(() => import("@/Pages/Coupons"));
export const AddPermissions = lazy(
  () => import("@/Pages/AddPermissions/AddPermissions")
);
export const BusinessNatures = lazy(() => import("@/Pages/NatureOfBusiness"));
export const ActivityLog = lazy(() => import("@/Pages/Activity"));
export const PaymentGateways = lazy(() => import("@/Pages/PaymentGateways"));
export const BlockedAreas = lazy(() => import("@/Pages/Block Areas"));
export const RaterConfig = lazy(() => import("@/Pages/RaterConfig"));
export const Occupations = lazy(() => import("@/Pages/Occupations"));
export const FeatureCategories = lazy(
  () => import("@/Pages/FeatureCategories/FeatureCategories")
);
export const Reports = lazy(() => import("@/Pages/Reports"));
export const EventTypes = lazy(() => import("@/Pages/EventTypes"));
export const PackagingTypes = lazy(() => import("@/Pages/PackagingTypes"));
export const Commissions = lazy(
  () => import("@/Pages/Commissions/Commissions")
);
export const Dashboard = lazy(() => import("@/Pages/Dashboard"));
export const Riders = lazy(() => import("@/Pages/Riders"));
export const AllSegments = lazy(() => import("@/Pages/AllSegments"));
export const Gadgets = lazy(() => import("@/Pages/Gadgets"));
export const KnockoutQuestions = lazy(
  () => import("@/Pages/KnockoutQuestions")
);
export const MedicalQuestions = lazy(() => import("@/Pages/MedicalQuestions"));
export const PartnerLandingPage = lazy(
  () => import("@/Pages/PartnerLandingPage")
);

export const BrokerLandingPage = lazy(
  () => import("@/Pages/BrokerLandingPage")
);
export const OccupancyType = lazy(() => import("@/Pages/Occupancy"));
export const IncoTerms = lazy(() => import("@/Pages/IncoTerms"));
export const Endorsements = lazy(() => import("@/Pages/Endorsements"));
export const PartnerCertificate = lazy(
  () => import("@/PartnerPages/Certificates")
);
export const PartnerUsers = lazy(
  () => import("@/PartnerPages/Users/PartnerUsers")
);
export const Claims = lazy(() => import("@/Pages/Claims"));
export const ClaimsTypes = lazy(() => import("@/Pages/ClaimTypes"));
export const ClaimExpenses = lazy(() => import("@/Pages/ClaimExpenses"));
export const ClaimStages = lazy(() => import("@/Pages/ClaimStages"));
export const AlertLogs = lazy(() => import("@/Pages/AlertLogs"));
export const ProposalBulkUpload = lazy(
  () => import("@/Pages/ProposalBulkUpload/ProposalUpload")
);

export const ClaimsDashbord = lazy(
  () => import("@/Pages/ClaimsDashboard/ClaimsDashboard")
);

export const QCRIframe = lazy(() => import("@/Pages/QMS/QCRIframePage"));
export const RFQIframe = lazy(() => import("@/Pages/QMS/RFQIframePage"));
export const PlacementSlipIframe = lazy(
  () => import("@/Pages/QMS/PlacementSlipIFrame")
);
export const PolicyListingIframe = lazy(
  () => import("@/Pages/BrocorePolicy/BrocorePolicy")
);
export const SalesTemplateIFrame = lazy(
  () => import("@/Pages/QMS/SalesTemplateIFrame")
);
export const Branches = lazy(() => import("@/Pages/Branches"));
export const ClaimSettlementType = lazy(
  () => import("@/Pages/ClaimSettlementType")
);

export const BrocoreClaims = lazy(
  () => import("@/Pages/BrocoreClaims/BrocoreClaims")
);

export const BrocoreEndorsements = lazy(
  () => import("@/Pages/BrocoreEndorsements/BrocoreEndorsements")
);
export const Template = lazy(() => import("@/Pages/Template"));
export const Renewals = lazy(() => import("@/Pages/Renewals/RenewalsIframe"));
export const SubSegments = lazy(() => import("@/Pages/SubSegment/SubSegment"));
export const Gender = lazy(() => import("@/Pages/Gender/Gender"));
export const Manufacturer = lazy(
  () => import("@/Pages/Manufacturer/Manufacturer")
);
export const FuelType = lazy(() => import("@/Pages/FuelTypes/FuelTypes"));
export const Variant = lazy(() => import("@/Pages/Variant/Variant"));
export const Model = lazy(() => import("@/Pages/Model/Model"));
export const Consent = lazy(() => import("@/Pages/Consent/Consent"));
export const Webhookspage = lazy(() => import("@/Pages/Webhooks/Webhooks"));
export const NotificationCenter = lazy(
  () => import("@/Pages/NotificationCenter/NotificationCenter")
);
export const ExecutiveDashboard = lazy(
  () => import("@/Pages/ExecutiveDashboard/ExecutiveDashboard")
);
export const IcApiConfiguratorPage = lazy(
  () => import("@/Pages/IcApiConfigurator/IcApiConfigurator")
);
